import React from 'react';
import { Global, css } from '@emotion/react';
import { useBreakpoints } from '@amzn/atoz-web/Responsive';

export const GlobalStyleReset: React.FC = () => {
    const { matches } = useBreakpoints();
    const isMobileViewport = !!matches.s;

    return (
        <Global
            styles={css`
                * {
                    box-sizing: border-box;
                }

                html,
                body {
                    font-size: 100%;
                    min-height: 100vh;
                }

                html {
                    font-family: sans-serif;
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                    -webkit-text-size-adjust: 100%;
                    text-rendering: optimizeLegibility;
                }

                // Make Banner have default ESSP Font: https://issues.amazon.com/issues/HMLTN-1931
                #page-header,
                #page-footer {
                    font-size: 14px;
                }

                // Overriding ESSP's z-index issue for their navbar: https://t.corp.amazon.com/P45917834
                nav.navbar-static-top {
                    z-index: 1;
                }

                // Overrides ESSPortal styles that makes the Stencil checkbox inaccessible
                input[type='checkbox'] {
                    display: inline-block !important;
                }

                // Opacity for GPSClockPunch component modals
                .modal-backdrop {
                    opacity: 0.5 !important;
                }
                // Resolving styling issue with the GPSClockPunch components
                .modal-body {
                    text-align: center;
                }
                .modal-dialog {
                    margin: auto;
                }

                // Set min-width for Stencil Modals for non-mobile views
                ${!isMobileViewport &&
                `
                  [data-test-component='StencilModal'] {
                      min-width: 544px;
                  }
                `}

                // make buttons fullwidth and vertical for mobile view
                ${isMobileViewport &&
                `
                  [data-test-component='StencilModalFooter'] {
                      flex-direction: column-reverse;
  
                      & > [data-test-component='StencilReactButton'] {
                          width: 100%;
                      }
                  }
                `}
            `}
        />
    );
};
